import React from 'react';
import { FormControlLabel, FormGroup } from '@mui/material';
import MuiSwitch from '../../../shared/components/MuiSwitch';
import visibilityValueFieldToTextMap from './visibilityValueFieldToTextMap';

/**
 * @typedef {object} VisibilitySettingsProps
 * @property {boolean} isEdit
 * @property {Object} [settings]
 * @property {(checked: boolean, valueField: string) => void} handleSettingChange
 * @property {boolean} loading
 */

/**
 * @param {VisibilitySettingsProps} props
 */
const VisibilitySettings = props => {
  const {
    handleSettingChange,
    isEdit,
    loading,
    settings = {
      VisibleOnAggregateAppraisalReport: false,
      VisibleOnDetailedAppraisalReport: false,
      VisibleOnAppraisalView: false,
      VisibleOnAppraisalComparison: false
    }
  } = props;

  const inputs = Array.from(visibilityValueFieldToTextMap).map(([valueField, text]) => {
    return (
      <FormControlLabel
        key={valueField}
        labelPlacement='start'
        label={text}
        className='setting-label'
        control={
          <MuiSwitch
            data-testid={`setting-input-${valueField}`}
            id={valueField}
            checked={settings[valueField]}
            onChange={(_, checked) => handleSettingChange(checked, valueField)}
            disabled={!isEdit}
            loading={loading}
          />
        }
      />
    );
  });

  return <FormGroup className='settings-container'>{inputs}</FormGroup>;
};

export default VisibilitySettings;
